<template>
  <section>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
  
    <el-row :gutter="10" class="mgb-20">
      <el-col :span="4">
        <!-- :src="img1" -->
        <div class="grid-content">
          <el-image
            class="img"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">12</span></p>
            <p>回收站总数（个）</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 查询条件 -->
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="120px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="请选择行政区划" prop="cityDetailId">
        <el-select v-model="searchForm.state" placeholder="全部">
          <el-option label="待发货" value="0"></el-option>
          <el-option label="已完成" value="1"></el-option>
          <el-option label="发货中" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="输入搜索" prop="keyword">
        <el-input
          v-model="searchForm.orderNo"
          placeholder="请输入回收站名称/编号"
          
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <btns @exec="exec"></btns>
   
    <div class="data-container scroll-table">
      <!-- 回收站 -->
      <el-table
        :data="tableData"
        border
        class="mgt-18"
        style="width: 100%"
        @selection-change="tableSelectionChange"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="customerName" label="编号">
        </el-table-column>
        <el-table-column prop="customerName" label="负责人">
        </el-table-column>
        <el-table-column prop="customerName" label="手机号"> </el-table-column>
        <el-table-column prop="customerName" label="地址">
        </el-table-column>
        <el-table-column prop="customerName" label="创建时间">
        </el-table-column>
        <el-table-column prop="customerStatus" label="操作">
          <template slot-scope="scope">
            <el-button>查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mgt-10 pd-0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.totalCount"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";
import Button from "../sys/button.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      searchForm: {
        totalCount: 0,
        current: 1,
        size: 10,
        keyword: "",
        cityDetailId: "", 
      },
      tableData: [],
      tableSelection: [],
    };
  },
  created() {
    this.query();
  },
  methods: {
    handleSizeChange(v) {
      this.searchForm.size = v;
      this.query();
    },
    handleCurrentChange(v) {
      this.searchForm.current = v;
      this.query();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.search();
    },
    search() {
      if (this.searchForm.name) {
        this.tableData = this.tableData.filter(
          (e) => e.btnName.indexOf(this.searchForm.name) >= 0
        );
      } else {
        this.query();
      }
    },
    query() {
      //获取接口
      this.$api.backstop
        .getHouseBackStopList(this.searchForm)
        .then((d) => {
          if (d.code == 200) {
            this.tableData = d.data;
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 回收总数
    queryCount() {
      //获取接口
      this.$api.backstop
        .getHouseBackStopCount(this.searchForm)
        .then((d) => {
          if (d.code == 200) {
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 行政区划
    citys() {
      //获取接口
      this.$api.stock
        .getAllList(this.searchForm)
        .then((d) => {
          if (d.code == 200) {
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    
    tableSelectionChange(val) {
      this.tableSelection = val;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
   
  },
};
</script>
<style scoped lang='less'>
.grid-content {
  display: flex;
  padding: 15px 10px;
  background-color: aliceblue;
  .img {
    width: 75px;
    height: 75px;
  }
  .total {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    flex: 1;
    padding-left: 10px;
  }
  p {
    margin: 0;
    display: flex;
    align-items: baseline;
  }
}
.font36 {
  font-size: 36px;
  margin-right: 5px;
}
.row{
  padding: 10px;
  min-height: 35px;
  box-sizing: border-box;
  border: 1px solid var(--table-border);
}
.flex1{
  flex:1;
  text-align: center;
}
.border-8e{
  border: 1px solid var(--table-border);
}
</style>